var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',[_c('b-row',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"img/brand/portadaplataforma.png","alt":"Kiwa dashboard"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }